module.exports = "<span [translate]=\"message\"></span>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/notification/notification-component/notification.component.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/notification/notification-component/notification.component.html
// module chunks = 1